import React, { useRef, useState, useCallback } from "react";
import { Ambulance } from "lucide-react";
import { ICON_STROKE } from "../ui/icon";

const NearbyFloatingHelp = ({ onCall }) => {
  const [expanded, setExpanded] = useState(false);
  const longPressRef = useRef(null);

  const callAmbulance = useCallback(() => {
    onCall({ name: "Ambulance", number: "108" });
    setExpanded(false);
  }, [onCall]);

  const startLongPress = () => {
    longPressRef.current = window.setTimeout(() => setExpanded(true), 450);
  };

  const cancelLongPress = () => {
    if (longPressRef.current) {
      window.clearTimeout(longPressRef.current);
      longPressRef.current = null;
    }
  };

  return (
    <div className="nearby-floating-help">
      {expanded && (
        <button type="button" className="nearby-floating-help__expand" onClick={callAmbulance}>
          <Ambulance size={18} strokeWidth={ICON_STROKE} />
          Call Ambulance
        </button>
      )}
      <button
        type="button"
        className="nearby-floating-help__desktop"
        onClick={callAmbulance}
      >
        <span className="nearby-floating-help__emoji" aria-hidden>
          🚑
        </span>
        <span>
          <strong>Need Help?</strong>
          <small>Call 108</small>
        </span>
      </button>
      <button
        type="button"
        className="nearby-floating-help__mobile"
        aria-label="Call 108 emergency. Long press for more options."
        onClick={() => {
          if (!expanded) callAmbulance();
        }}
        onTouchStart={startLongPress}
        onTouchEnd={cancelLongPress}
        onTouchCancel={cancelLongPress}
        onMouseDown={startLongPress}
        onMouseUp={cancelLongPress}
        onMouseLeave={cancelLongPress}
      >
        <span aria-hidden>🚑</span>
      </button>
    </div>
  );
};

export default NearbyFloatingHelp;
